import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { BehaviorSubject, Observable } from 'rxjs';
import { HistoryData } from './import-history-model';
import { finalize } from 'rxjs/operators';
import { ImportHistoryService } from './import-history.service';

export class ImportHistoryDataSource implements DataSource<HistoryData> {

  private dataSubject = new BehaviorSubject<HistoryData[]>([]);
  private dataLengthSubject = new BehaviorSubject<number>(0);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public data = this.dataSubject.asObservable();
  public dataLength = this.dataLengthSubject.asObservable();
  public loading = this.loadingSubject.asObservable();

  constructor(private importHistoryService: ImportHistoryService) {}

  connect(collectionViewer: CollectionViewer): Observable<HistoryData[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadHistory(
    pageIndex: number,
    pageSize: number,
    sortBy: string = 'created',
    sortDirection: string = 'asc',
    filter: string = '',
  ) {

    this.loadingSubject.next(true);

    this.importHistoryService
      .findPaginated(
        pageIndex,
        pageSize,
        sortBy,
        sortDirection,
        filter
      )
      .pipe(
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(data => {
        this.dataSubject.next(data._embedded.import_history);
        this.dataLengthSubject.next(data.total_items);
      });
  }
}
